module.exports = __webpack_public_path__ + "img/bandarur.9e2553d9.jpg";